import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";
import { useModalStore } from "./modal.store";
import axios from "@/config";
import { useErrorStore } from "./error.store";

let debouncedFetch = debounce(getData, 500);

export const useUserStore = defineStore({
  id: "user",
  state: () => ({
    users: {},
    userById: {},
    loading: false,
    limit: 20,
    offset: 0,
    page: 1,
    length: 0,
    q: "",
  }),
  getters: {
    getState(state) {
      return state.users.data;
    },
  },
  actions: {
    async getAllUser(params) {
      this.users = { loading: true };

      const dataparams = {
        limit: params?.limit || 20,
        offset: params?.offset || 0,
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("user", dataparams);
        this.users = { ...result.data };
      } catch (error) {
        console.log(error);
        this.users = { error };
      }
    },

    async getUserById(userid) {
      try {
        const result = await debouncedFetch("user/" + userid);
        this.userById = { ...result.data };
      } catch (error) {
        console.log(error);
        this.userById = { error };
      }
    },

    async addUser(username, name, password, role) {
      this.loading = true;
      const modal = useModalStore();

      try {
        await axios.post("user", {
          username: username,
          name: name,
          password: password,
          role: role,
        });
        this.loading = false;
        modal.closeModal();
        this.getAllUser({});
      } catch (error) {
        this.loading = false;
        modal.closeModal();
        const errorStore = useErrorStore();
        errorStore.open = true;
        errorStore.retry = false;
        errorStore.message = error.response.data.message;
      }
    },

    async deleteUser(id) {
      this.loading = true;
      const modal = useModalStore();

      try {
        await axios.delete(`user/${id}`);
        this.loading = false;
        modal.closeModal();
        this.page = 1;
        this.offset = 0;
        this.q = "";
        await this.getAllUser({ offset: this.offset });
        this.length = this.users.count;
      } catch (error) {
        this.loading = false;
        modal.closeModal();
        const errorStore = useErrorStore();
        errorStore.open = true;
        errorStore.retry = false;
        errorStore.message = error.response.data.message;
      }
    },
  },
});
